import numberFormat from "./numberFormat";

export const randomIntFromInterval = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
};

export const format = (number = 0) => {
    const formattedNumber = numberFormat(number, 0, '', '.');
    return formattedNumber;
}

export default { randomIntFromInterval, format };